import { EscalationLevelBadge } from '../badges/EscalationLevelBadge';

import type { P1ChainVM } from '../../view-models';
import type React from 'react';

export interface EscalationChainCardProps {
  chain: P1ChainVM;
}

/**
 * Escalation chain proposta (.escalation-chain) — converte cards-3.jsx verbatim.
 * "score atual" + próximo nível derivado + steps do histórico real (D4).
 * T8-1 read-only: os botões de ação do protótipo (Aceitar/Reverter/Protocolo)
 * NÃO entram aqui — o ciclo de vida vive no drawer de detalhe (T8-2, D6).
 */
export function EscalationChainCard({ chain }: EscalationChainCardProps): React.JSX.Element {
  return (
    <div className="escalation-chain">
      <div className="escalation-chain__head">
        <span className="escalation-chain__score">{chain.currentScore}</span>
        <span className="tweaks-hint">score atual</span>
        <span style={{ flex: 1 }} />
        {chain.nextLevelLabel !== null && (
          <span className="tweaks-hint">
            próximo: <b>{chain.nextLevelLabel}</b>
          </span>
        )}
      </div>
      <ol className="escalation-chain__steps">
        {chain.steps.map((s, i) => (
          <li
            key={`${s.level}-${i.toString()}`}
            className={
              'escalation-chain__step' + (s.current ? ' escalation-chain__step--current' : '')
            }
          >
            <span className="escalation-chain__dot" aria-hidden="true" />
            <EscalationLevelBadge level={s.level} current={s.current} />
            <span className="escalation-chain__score-small mono">{s.score}</span>
            <span className="tweaks-hint">{s.atLabel}</span>
          </li>
        ))}
        {chain.nextLevel !== null && (
          <li className="escalation-chain__step escalation-chain__step--next">
            <span
              className="escalation-chain__dot escalation-chain__dot--empty"
              aria-hidden="true"
            />
            <EscalationLevelBadge level={chain.nextLevel} />
            <span className="tweaks-hint">próximo</span>
          </li>
        )}
      </ol>
    </div>
  );
}
